export default {
  withdraw: {
    title: 'निकासी',
    subtitle: 'तेज़, सुरक्षित और सुविधाजनक',
    secureEncrypted: 'सुरक्षित और एन्क्रिप्टेड',
    fiatOrCash: 'फिएट/नकद',
    processing: 'प्रोसेस हो रहा है...',
    select: 'चुनें',
    withdrawCurrency: 'निकासी मुद्रा',
    chooseNetwork: 'नेटवर्क चुनें',
    channel: 'चैनल',
    withdrawalAddress: 'निकासी पता',
    pixKeyType: 'PIX की प्रकार',
    accountNumber: 'खाता संख्या',
    enterAccountNumber: 'अपनी खाता संख्या दर्ज करें',
    accountName: 'खाता नाम',
    enterAccountName: 'खाताधारक का नाम दर्ज करें',
    pixKey: 'PIX की',
    enterPixKey: 'अपनी PIX की दर्ज करें',
    cpf: 'CPF',
    enterCpf: 'CPF दर्ज करें',
    bankName: 'बैंक का नाम',
    enterBankName: 'बैंक का नाम दर्ज करें',
    branch: 'शाखा',
    enterBranch: 'शाखा दर्ज करें (वैकल्पिक)',
    phone: 'फ़ोन',
    enterPhone: 'फ़ोन दर्ज करें (वैकल्पिक)',
    email: 'ईमेल',
    enterEmail: 'ईमेल दर्ज करें (वैकल्पिक)',
    available: 'निकासी योग्य',
    amountPlaceholder: 'राशि ({unit})',
    min: 'न्यूनतम',
    max: 'अधिकतम',
    totalWithdrawalAmount: 'कुल निकासी राशि:',
    fee: 'शुल्क:',
    withdrawalAmount: 'निकासी राशि:',
    fundsSafeTitle: 'आपकी राशि हमारे पास सुरक्षित है',
    fundsSafeDesc: 'हम आपके लेन-देन और व्यक्तिगत जानकारी की सुरक्षा के लिए उद्योग की अग्रणी सुरक्षा का उपयोग करते हैं।',
    enterWithdrawalAddress: 'कृपया निकासी पता दर्ज करें',
    enterAccountNumberRequired: 'कृपया अपनी खाता संख्या दर्ज करें',
    selectChannelRequired: 'कृपया एक चैनल चुनें',
    enterAccountNameRequired: 'कृपया खाताधारक का नाम दर्ज करें',
    selectPixKeyTypeRequired: 'कृपया PIX की प्रकार चुनें',
    enterCpfRequired: 'कृपया CPF दर्ज करें',
    enterValidAmount: 'कृपया एक वैध राशि दर्ज करें',
    minWithdrawal: 'न्यूनतम निकासी: {amount} {unit}',
    maxWithdrawal: 'अधिकतम निकासी: {amount} {unit}',
    insufficientBalance: 'उपलब्ध शेष राशि अपर्याप्त है',
    withdrawalRejected: 'निकासी अस्वीकृत',
    submittedPendingReview: 'निकासी सबमिट की गई, समीक्षा लंबित है',
    submittedPayoutInProgress: 'निकासी सबमिट की गई, भुगतान प्रगति पर है',
    withdrawalFailed: 'निकासी विफल',
    withdrawalFailedRetry: 'निकासी विफल, कृपया पुनः प्रयास करें',
  },
};
